var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApTestingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H35C40.5228 0 45 4.47715 45 10V35C45 40.5228 40.5228 45 35 45H10C4.47715 45 0 40.5228 0 35V10Z",
    fill: "#FFF4E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3413 34.0136H32.3446C33.4255 34.0136 34.3196 33.1195 34.3196 32.0386L34.3463 32.0119C34.3463 30.9177 33.4255 30.0103 32.3446 30.0103H28.3413V34.0136Z",
    stroke: "#F2B132",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3413 26.007H31.6774C32.7984 25.9936 33.6791 26.8877 33.6791 28.0087C33.6791 29.1296 32.7984 30.0103 31.6774 30.0103H28.3413V26.007Z",
    stroke: "#F2B132",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3276 18.0003V12.6625C12.3276 11.2801 13.522 9.99365 14.9965 9.99365C16.4711 9.99365 17.6654 11.2801 17.6654 12.6625V18.0003",
    stroke: "#F2B132",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.98 21.9768C10.98 25.1621 12.2453 28.2169 14.4976 30.4692C16.7499 32.7215 19.8047 33.9868 22.99 33.9868M35 21.9768C35 18.7916 33.7347 15.7368 31.4824 13.4844C29.23 11.2321 26.1752 9.9668 22.99 9.9668",
    stroke: "#F2B132",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6654 15.3311H12.3276",
    stroke: "#F2B132",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApTestingIcon);
export default __webpack_public_path__ + "static/media/ap-testing-icon.81d6f543ce4bbb2f3ea5d0a8331ed92f.svg";
export { ForwardRef as ReactComponent };